import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import { OverlayTrigger, Popover, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';
import { toastr } from 'react-redux-toastr';
import { Link } from 'react-router';
import Confirm from 'react-confirm-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setLoader, removeLoader, toggleRemovedCampaigns } from '../../../actions';
import { AdvertiserApi } from '../../../api';
import { demoCampaigns } from '../../../utils/constants';
import { convertMillsToDollars } from '../../../utils/helpers/currency';
import { Spinner } from '../../common';

const statusType = {
  removed: -1,
  paused: 0,
  active: 1
};

const friendlyStatus = {
  paused: 0,
  running: 4,
  'pending-approval': 3,
  'daily-budget-reached': 2,
  'campaign-ended': 1,
  removed: -1
};


class CampaignIndexTable extends Component {

  handlePauseCampaign(campaign, action) {
    const { dispatch, account, campaigns } = this.props;
    const args = [account.uuid, campaign.id, {
      status: action === 'Pause' ? 'paused' : 'active'
    }];
    document.body.click();
    dispatch(setLoader('CampaignStatusUpdate'));
    dispatch(AdvertiserApi.actions.standardCampaignUpdate.patch(...args, (error, success) => {
      dispatch(removeLoader('CampaignStatusUpdate'));
      if (success) {
        const collection = [...campaigns.data].map((obj) => {
          return obj.uuid === success.data.uuid ? success.data : obj;
        });

        dispatch({
          type: AdvertiserApi.events.campaigns.actionSuccess,
          syncing: false,
          data: { ...campaigns, data: collection, meta: { ...campaigns.meta } }
        });
        toastr.success(`${success.data.name} Campaign ${action === 'Pause' ? 'paused' : 'resumed'} successfully`);
      }
    }));
  }

  handleRemoveCampaign(campaign) {
    const { dispatch, account, campaigns } = this.props;
    const args = [
      campaign.id, {
        account_id: account.uuid
      }
    ];

    document.body.click();
    dispatch(AdvertiserApi.actions.standardCampaignDelete.delete(...args, (error, success) => {
      if (success) {
        const collection = [...campaigns.data].map((obj) => {
          return obj.referencenumber === success.referencenumber ? { ...obj, status: 'removed', effective_status: 'campaign_removed' } : obj;
        });
        dispatch({
          type: AdvertiserApi.events.campaigns.actionSuccess,
          syncing: false,
          data: { ...campaigns, data: collection, meta: { ...campaigns.meta } }
        });
        toastr.success('Campaign removed successfully');
      }
    }));
  }

  handleShowRemovedCampaigns() {
    const { dispatch } = this.props;
    dispatch(toggleRemovedCampaigns());
  }

  handleStatusPopover(c, r) {
    const action = (['active', 'pending'].includes(r.status)) ? 'Pause' : 'Resume';
    return r.status !== 'removed' ? (
      <OverlayTrigger
        arrowProps
        trigger="click"
        placement="right"
        delay={100}
        rootClose
        overlay={
          <Popover
            id={`${c}-popover`}
          >
            <Button style={{ width: '100%' }} onClick={this.handlePauseCampaign.bind(this, r, action)}>
              {action} Campaign
              </Button>
            <br />
            <Confirm
              onConfirm={this.handleRemoveCampaign.bind(this, r)}
              body={
                <div>
                  <h4>Are you sure you want to delete this campaign?</h4>
                  <ul>
                    <li>You will <strong>not</strong> be able to resume this campaign once it is deleted.</li>
                    <li>Your ads will be <strong>accessible for 30 days</strong> before they will be retired from our network</li>
                    <li>The campaign performance data will <strong>always</strong> be accesible</li>
                  </ul>
                </div>
              }
              confirmText='Confirm Delete'
              title={`Removing Campaign: ${r.name}`}
            >
              <Button
                bsStyle='danger'
              >
                Remove Campaign
              </Button>
            </Confirm>
          </Popover>
        }
      >
        <div className={`campaign circle ${r.status}`}>
          &nbsp; <FontAwesomeIcon icon='caret-right' />
        </div>
      </OverlayTrigger>
    ) : (
      <div className={`campaign circle ${r.status}`} />
    );
  }

  handleEndDate(c, r) {
    let endDate = 'Recurring';
    if (!c && !r.recurring) {
      endDate = moment().local().endOf('month').format('MMMM Do[,] YYYY');
    } else if (c) {
      endDate = moment(c).local().format('MMMM Do[,] YYYY');
    }
    return endDate;
  }

  handleDisabledRow(row) {
    if (row.status === 'removed') {
      return 'removed-disable';
    }
  }

  sortEndDate(a, b, order) {
    const aVal = moment(a.end_date || undefined);
    const bVal = moment(b.end_date || undefined);

    if (order === 'asc') {
      if (aVal > bVal) {
        return 1;
      } else if (aVal < bVal) {
        return -1;
      } else if (a.recurring) {
        return -1;
      }
    }

    if (aVal < bVal) {
      return 1;
    } else if (aVal > bVal) {
      return -1;
    } else if (b.recurring) {
      return -1;
    }
    return 0;
  }

  sortFriendlyStatus(a, b, order) {
    if (order === 'asc') {
      if (friendlyStatus[b.friendly_status] > friendlyStatus[a.friendly_status]) {
        return -1;
      } else if (friendlyStatus[b.friendly_status] < friendlyStatus[a.friendly_status]) {
        return 1;
      }
    }

    if (friendlyStatus[b.friendly_status] < friendlyStatus[a.friendly_status]) {
      return -1;
    } else if (friendlyStatus[b.friendly_status] > friendlyStatus[a.friendly_status]) {
      return 1;
    }
    return 0;
  }

  sortStatus(a, b, order) {
    if (order === 'asc') {
      if (statusType[b.status] > statusType[a.status]) {
        return -1;
      } else if (statusType[b.status] < statusType[a.status]) {
        return 1;
      }
    }

    if (statusType[b.status] < statusType[a.status]) {
      return -1;
    } else if (statusType[b.status] > statusType[a.status]) {
      return 1;
    }
    return 0;
  }

  showDemoData() {
    const { useDemo, campaigns } = this.props;
    if (campaigns.data && campaigns.data.length > 0) {
      return false;
    }

    return useDemo;
  }

  showSortedReports() {
    const { sortedReports, settings } = this.props;

    return settings.showRemovedCampaigns ? sortedReports : sortedReports.filter(campaign => {
      return campaign.status !== 'removed';
    });
  }

  render() {
    const { campaignsIsLoading, account, settings } = this.props;
    const data = this.showDemoData.bind(this)() ?
      demoCampaigns : this.showSortedReports.bind(this)();

    const perPageList = [
      { text: '10', value: 10 },
      { text: '20', value: 20 },
      { text: '50', value: 50 },
      { text: 'ALL', value: data.length }
    ];

    const options = {
      sizePerPageList: perPageList,
      pageStartIndex: 1
    };

    return (
      <Row className={`ibox-content${campaignsIsLoading ? ' sk-loading' : ''}`}>
        <Spinner />
        <Row style={{ marginBottom: '15px' }}>
          <Col md={12}>
            {this.props.children}
            <div className='pull-right'>
              <input
                id="show-removed-campaigns"
                type="checkbox"
                style={{ marginLeft: '5px', marginRight: '5px' }}
                checked={settings.showRemovedCampaigns}
                onChange={this.handleShowRemovedCampaigns.bind(this)}
              />
              <label
                htmlFor="show-removed-campaigns"
              >
                Show Removed
              </label>
            </div>
          </Col>
        </Row>

        <BootstrapTable
          striped
          ref='CampaignsTable'
          data={data || []}
          bodyContainerClass={`${this.showDemoData.bind(this)() ? 'demo-on' : ''}`}
          trClassName={this.handleDisabledRow}
          pagination
          options={options}
        >
          <TableHeaderColumn
            isKey
            width="50px"
            dataField="uuid"
            dataFormat={this.handleStatusPopover.bind(this)}
            dataSort
            sortFunc={this.sortStatus}
          />

          <TableHeaderColumn
            width="200px"
            dataField="name"
            dataFormat={(c, r) => {
              return (
                <Link
                  to={`/advertiser/home/accounts/${account.slug}/campaigns/${r.id}`}
                >
                  {c}
                </Link>
              );
            }}
            dataSort
          >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            width="150px"
            dataField="effective_status"
            dataFormat={(c) => c}
            dataSort
            sortFunc={this.sortFriendlyStatus}
          >
            Status
          </TableHeaderColumn>

          <TableHeaderColumn
            width="100px"
            dataField="clicks"
            dataFormat={(c) => {
              return (c ? c : 0);
            }}
            dataSort
          >
            Clicks
          </TableHeaderColumn>

          <TableHeaderColumn
            width="125px"
            dataField="impressions"
            dataFormat={(c) => {
              return (c ? c : 0);
            }}
            dataSort
          >
            Impressions
          </TableHeaderColumn>

          <TableHeaderColumn
            width="100px"
            dataField="ctr"
            dataFormat={(c) => {
                return (c ? c.toFixed(2) : '0.00');
            }}
            dataSort
          >
            CTR(%)
          </TableHeaderColumn>

          <TableHeaderColumn
            width="125px"
            dataField="conversions"
            dataFormat={(c) => {
              return (c ? c : '0.00');
            }}
            dataSort
          >
            Applications
          </TableHeaderColumn>

          <TableHeaderColumn
            width="150px"
            dataField="spend"
            dataFormat={(c, r) => {
              return `${(convertMillsToDollars(c ? c : 0))} / ${convertMillsToDollars(r.budget)}`;
            }}
            dataSort
          >
            Spent/Budget($)
          </TableHeaderColumn>

          <TableHeaderColumn
            width="125px"
            dataField="end_date"
            dataFormat={this.handleEndDate}
            dataSort
            sortFunc={this.sortEndDate}
          >
            End Date
          </TableHeaderColumn>
        </BootstrapTable>
      </Row>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    loader,
    advertiser: {
      campaigns: {
        data: campaigns,
        loading: campaignsIsLoading
      },
      campaignReports: {
        data: campaignReports,
        loading: campaignReportsIsLoading
      }
    },
    settings
  } = state;
  const account = ownProps.account;
  const useDemo = ownProps.useDemo;
  const totaledReports = {};
  const sortedReports = [];

  if (campaignReports.data && campaigns.data) {
    campaignReports.data.forEach((currentValue) => {
      totaledReports[currentValue.referencenumber] = totaledReports[currentValue.referencenumber] ||
      {
        count: 0,
        clicks: 0,
        conversions: 0,
        impressions: 0,
        spend: 0,
      };

      totaledReports[currentValue.referencenumber].count++;
      totaledReports[currentValue.referencenumber].clicks += currentValue.clicks;
      totaledReports[currentValue.referencenumber].conversions += currentValue.conversions;
      totaledReports[currentValue.referencenumber].impressions += currentValue.impressions;
      totaledReports[currentValue.referencenumber].spend += currentValue.spend;
    });

    campaigns.data.forEach((campaign) => {
      const totalReport = totaledReports[campaign.referencenumber];
      sortedReports.push({
        ...totalReport,
        ...campaign,
        ctr: totalReport ? (totalReport.clicks / (totalReport.impressions || 1)) : 0
      });
    });

    sortedReports.sort((campaign) => {
      let value = 0;
      if (campaign.status === 'removed') {
        value = 1;
      }
      return value;
    });
  }

  return {
    account,
    useDemo,
    campaigns,
    campaignsIsLoading,
    campaignReports,
    campaignReportsIsLoading,
    totaledReports,
    sortedReports,
    statusLoading: loader.includes('CampaignStatusUpdate'),
    settings,
  };
};
export default connect(mapStateToProps)(CampaignIndexTable);

